import Hosts from '../../../Hosts';

const object_type = '*'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities`
const api_list_route = companycode => `${Hosts.SIMCore_API}/entities/list/${companycode}/${object_type}`

const base_endpoint = '/entidade_externa'
const regist = '/entidade'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        username: '',
        password: '',
        name: '', //ARMAZENO DO NOME COMERCIAL
        foto: [], //ARMAZENO DA FOTO
        rgpd: false,
        ativo: true,
        birthday: '',

        vat: '',
        iban: '',
        nbss: '',
        ass: '',   
        arquivo: '',     
        numero_contribuinte: '',
        validade_contribuinte: '',
        identificacao: {
            tipo_identificacao: '',
            numero_identificacao: '',
            validade_identificacao: ''
        },

        data_admissao: '',
        tipo_contrato: '',
        horas_semanais: '',
        seguro_acidente_trabalho: '',

        notify:[],
        observation: '',
        type: [],
        relacao: [],
        tag:'',
        imagem:'',
        cv: {},
        sexo: '',
        estado_civil: '',
        habilitacao_literaria: '',
    },

    addresses: [{
        village: '',
        city: '',
        entity: [],
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],

    contacts: [{
        name: '', //ARMAZENO DO NOME INSTITUCIONAL
        email: '',        
        principal: 'true',
        extensions: [],
        observation: '',
        phone:  '',
        mobile_phone: '',
        building_number: '',
        person_responsables: [{
            name: '',
            email: '',
            extensions: '',
            observation: '',
            phone: '',
            mobile_phone: ''
        }],
                
        departamento: [{ 
            id: '', 
            name: '', 
            software: []
        }],    
    }],

    profile: { id: '11', name: 'Entidade' },
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
